import {
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  Hidden,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AvatarImage from "../../assets/images/LoginImage.png";
import CenteredContent from "../../components/sharedComponents/CenteredContent";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import LoginPageStyles from "./LoginPage.styles";
import LockIcon from "@material-ui/icons/Lock";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ROUTES_CONSTANTS } from "../../constants/routesConstants";
import { loginUser } from "../../api/apiAuth";
import {
  selectLogedUserType,
  setIsAuth,
  setLogedUserInformation,
} from "../../store/slices/user";
import { setAccessToken } from "../../store/slices/clients";
import { ERROR_MESSAGES } from "../../constants/constantMessages";
import { setCookie } from "../../utils/sessionCookie";
import { getInfoHome } from "../../api/home";
import {
  setClientsHome,
  setInvoicesHome,
  setLastInvoices,
  setLastUpdateInfo,
  setMonthlySales,
  setTotalInvoices,
  setWeeklyCollection,
} from "../../store/slices/home";
import moment from "moment-timezone";
import { errors } from "../../utils/ErrorAxios";
import useLogout from "../../hooks/useLogout";

const LoginPage = () => {
  const classes = LoginPageStyles();

  const userNavigation = (userType) => {
    if (userType === 2) {
      history.push(ROUTES_CONSTANTS.ADMIN);
    } else if (userType === 7) {
      history.push(ROUTES_CONSTANTS.PARTNER_DETAILS);
    }
  };

  //Password input
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [errorAuth, setErrorAuth] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorFields, setErrorFields] = useState({
    user: false,
    password: false,
  });

  const history = useHistory();
  const dispatch = useDispatch();
  const [logout] = useLogout();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleLogin = () => {
    if (!user || !password) {
      setErrorFields({ user: !user, password: !password });
      setLoading(false);
      return;
    }

    const currentDateTime = moment()
      .tz("America/Mexico_City")
      .format("D [de] MMMM [del] YYYY [a las] h:mm A");
    setLoading(true);
    loginUser(user, password)
      .then(({ data }) => {
        if (data.statusCode === 200 && data.statusMessage === "Login correct") {
          // if the user is active and admin
          error && setError(false);
          dispatch(setLogedUserInformation(data.body));
          dispatch(setIsAuth(true));
          dispatch(setAccessToken(data.body.token));
          setCookie("accessToken", data.body.token);
          //Llamada a la API 'getInfoHome' despues de un login exitoso
          getInfoHome(data.body.token)
            .then((res) => {
              if (res && res.data) {
                const homeData = res.data.body;
                dispatch(setClientsHome(homeData.clients));
                dispatch(setWeeklyCollection(homeData.weeklyCollection));
                dispatch(setInvoicesHome(homeData.invoices));
                dispatch(setTotalInvoices(homeData.totalInvoices));
                dispatch(setMonthlySales(homeData.monthlySales));
                dispatch(setLastInvoices(homeData.lastInvoices));
                dispatch(setLastUpdateInfo(currentDateTime));

                userNavigation(data.body.idUserType);
              } else {
                console.error("No data received from getInfoHome");
              }
            })
            .catch(({ err }) => {
              errors(err, "No se pudo obtener la información", logout);
              setLoading(false);
            });
        } else {
          setLoading(false);
          setError(true);
          setErrorAuth(false);
        }
      })
      .catch(({ err }) => {
        errors(err, "No se pudo obtener la información", logout);
        setLoading(false);
        setError(true);
      });
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();

        handleLogin();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [handleLogin]);

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={6}
        className={classes.imageLoginContainer}
      >
        <Typography variant="h1" align="left" className={classes.navickLogo}>
          Navick
        </Typography>
        <CenteredContent direction="column">
          <Hidden mdDown>
            <Typography variant="h1" className={classes.LoginSlogan}>
              Administra, consulta y actualiza de una mejor manera toda tu
              información.
            </Typography>
          </Hidden>
          <img src={AvatarImage} alt="avatar" className={classes.avatarImage} />
        </CenteredContent>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={6}>
        <form>
          <CenteredContent direction="column">
            <Hidden mdDown>
              <Typography variant="h1" className={classes.navickTitle}>
                Navick
              </Typography>
            </Hidden>
            <Typography variant="h1" className={classes.iniciarSesionText}>
              Ingresa a tu cuenta
            </Typography>
            <TextField
              variant="outlined"
              label="Usuario"
              className={classes.inputUser}
              placeholder="Ingresa tu usuario"
              value={user}
              onChange={(e) => {
                setUser(e.target.value);
                if (errorFields.user && e.target.value.trim() !== "") {
                  setErrorFields((prev) => ({ ...prev, user: false }));
                }
              }}
              error={errorFields.user}
              helperText={errorFields.user ? "*El usuario es obligatorio*" : ""}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      aria-label="contrasena"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      <AccountCircleIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                autocomplete: "new-password",
                form: {
                  autocomplete: "off",
                },
              }}
            />
            <TextField
              variant="outlined"
              label="Contraseña"
              id="contrasena"
              autoComplete="off"
              className={classes.inputPassword}
              type={showPassword ? "text" : "password"}
              placeholder="Ingresa tu contraseña"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (errorFields.password && e.target.value.trim() !== "") {
                  setErrorFields((prev) => ({ ...prev, password: false }));
                }
              }}
              error={errorFields.password}
              helperText={
                errorFields.password ? "*La contraseña es obligatoria*" : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="contrasena"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      aria-label="contrasena"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      <LockIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                autocomplete: "new-password",
                form: {
                  autocomplete: "off",
                },
              }}
            />
            <FormHelperText error={error}>
              {error && (
                <Typography
                  variant="subtitle1"
                  className={classes.errorMessage}
                >
                  El usuario o el password son incorrectos
                </Typography>
              )}
            </FormHelperText>
            <FormHelperText error={error}>
              {errorAuth && (
                <Typography
                  variant="subtitle1"
                  className={classes.errorMessage}
                >
                  No tienes los permisos para acceder
                </Typography>
              )}
            </FormHelperText>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonLogin}
              onClick={handleLogin}
            >
              {loading && (
                <CircularProgress
                  size={20}
                  style={{ color: "white", marginRight: 10 }}
                />
              )}
              {loading ? "Iniciando" : "Continuar"}
            </Button>
          </CenteredContent>
        </form>
      </Grid>
    </Grid>
  );
};

export default LoginPage;
